import axiosInstance from '@/utils/api.js'

var state = {
  buildings: [],
  buildings_paged: [],
  free_ips: []
}

var getters = {
  BUILDINGS: (state) => {
    return state.buildings
  },
  BUILDINGS_PAGED: (state) => {
    return state.buildings_paged
  },
  FREE_IPS_OF_BUILDING: (state) => {
    return state.free_ips
  }
}

var mutations = {
  SET_BUILDINGS: (state, payload) => {
    state.buildings = payload
  },
  SET_BUILDINGS_PARAMS: (state, payload) => {
    state.buildings_paged = payload
  },
  SET_FREE_IP_BUILDINGS: (state, payload) => {
    state.free_ips = payload
  }
}

var actions = {
  GET_BUILDINGS: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/houses')
    if (result.status === 200) {
      context.commit('SET_BUILDINGS', result.data)
    }
  },
  GET_BUILDINGS_PARAMS: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/houses_paged?filter=' + payload.filter +
    '&per_page=' + payload.per_page + '&page=' + payload.page)
    if (result.status === 200) {
      context.commit('SET_BUILDINGS_PARAMS', result.data)
    }
  },
  GET_FREE_IP_OF_BUILDINGS: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/free_ips_for_house?house_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_FREE_IP_BUILDINGS', result.data)
    }
  },
  GET_FREE_IP_OF_BUILDINGS_BY_UID: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/free_ips_for_house_by_uid?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_FREE_IP_BUILDINGS', result.data)
    }
  },
  CREATE_BUILDINGS: (context, payload) => {
    return axiosInstance.post('/referencebooks/houses', payload)
  },
  UPDATE_BUILDINGS: (context, payload) => {
    return axiosInstance.put('/referencebooks/houses', payload)
  },
  DELETE_BUILDINGS: (context, payload) => {
    return axiosInstance.delete('/referencebooks/houses?house_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/referencebooks/buildings.js